import config from '../../config/customer.api'
import { appInsights } from '../shared/applicationInsights'
import { Request } from '../shared/base.requests'

const loginModule = {
  namespaced: true,
  state: {
    isAuthorized: false,
    isRegistered: false,
    sharedItemId: null
  },
  mutations: {
    // updateLoginScreenState (state, isOpened) {
    //   let previousState = state.isLoginScreenOpen
    //   if (previousState === isOpened) {
    //     console.warn(' - update login screen visibility will have no affect, isLoginScreenOpen is already, ', isOpened)
    //     return
    //   }
    //   state.isLoginScreenOpen = isOpened
    // },
    updateToken (state, payload) {
      state.isAuthorized = Boolean(payload)
      if (payload) {
        localStorage.token = payload
      } else {
        localStorage.removeItem('token')
      }
    },
    updateAccessId (state, payload) {
      state.isAuthorized = Boolean(payload)
      if (payload) {
        localStorage.accessId = payload
      } else {
        localStorage.removeItem('accessId')
      }
    },
    updateRegistration (state, payload) {
      state.isRegistered = payload
    },
    setSharedItemId (state, sharedItemId) {
      state.sharedItemId = sharedItemId
    }
  },
  actions: {
    auth: function (context, {tokenId}) {
      const endpoint = config.set_auth + '?token=' + tokenId
      return new Promise((resolve, reject) => {
        Request.get(endpoint)
          .then((response) => {
            console.log(response)
            if (!response.success) {
              throw new Error(response.message || 'auth failed')
            }
            context.commit('updateToken', response.model.accessToken)
            context.commit('updateRegistration', response.model.isRegistered)
            context.commit('updateAccessId', tokenId)
            resolve(response.model)
          })
          .catch((e) => {
            appInsights.trackException({
              exception: e,
              message: e.message,
              properties: {
                apiUrl: endpoint,
                accessId: localStorage.accessId
              }
            })
            appInsights.flush()
            reject(e)
          })
      })
    },
    init: function (context) {
      return new Promise((resolve) => {
        const token = localStorage.token || null
        context.commit('updateToken', token)
        resolve()
      })
    },
    // loginScreenWillShow (context, payload) {
    //   context.commit('updateLoginScreenState', true)
    // },
    // loginScreenDidHide (context, payload) {
    //   context.commit('updateLoginScreenState', false)
    // },
    // clearPinNonce (context, payload) {
    //   context.commit('updatePinNonce')
    //
    // },
    setRegisterDate: function (context) {
      return new Promise((resolve, reject) => {
        if (localStorage.token === undefined || localStorage.token == null) {
          console.log('No Authorization')
          return resolve()
        }

        if (localStorage.token) {
          context.commit('updateToken', localStorage.token)
        }
        let sharedItemId = context.state.sharedItemId
        Request.post(config.set_registration, sharedItemId)
          .then((response) => {
            context.commit('updateRegistration', true)
            context.commit('setSharedItemId', null)
            resolve()
          })
          .catch((error) => {
            console.error('setMakes failed', error)
            reject()
          })
      })
    },
    setInstalledDate: function (context, model) {
      return new Promise((resolve, reject) => {
        if (localStorage.token === undefined || localStorage.token == null) {
          console.log('No Authorization')
          resolve
          return
        }

        if (model.isStandalone !== true) {
          resolve
          return
        }

        let sharedItemId = context.state.sharedItemId
        Request.post(config.set_installed, sharedItemId)
          .then((response) => {
            context.commit('setSharedItemId', null)
            resolve()
          })
          .catch((error) => {
            console.error('setInstalledDate failed', error)
            reject()
          })
      })
    },
    setSharedItemId (context, sharedItemId) {
      context.commit('setSharedItemId', sharedItemId)
    }
  },
  getters: {}
}

export default loginModule



// WEBPACK FOOTER //
// ./scripts/src/store/login.module.js